import Icon from '../components/Icon.vue'

Icon.register({"heartbeat":{"width":512,"height":512,"paths":[{"d":"M320.2 243.8L270.5 343.2C264.5 355.3 247.1 354.9 241.6 342.6L184.7 216.3 154.7 288H60.6L243.1 474.5C250.2 481.8 261.7 481.8 268.8 474.5L451.4 288H342.3L320.2 243.8zM473.7 73.9L471.3 71.4C419.8 18.8 335.5 18.8 283.9 71.4L256 100 228.1 71.5C176.6 18.8 92.2 18.8 40.7 71.5L38.3 73.9C-10.4 123.7-12.5 203 31 256H133.4L169.3 169.8C174.7 156.9 192.9 156.6 198.7 169.4L256.9 298.7 305.9 200.8C311.8 189 328.6 189 334.5 200.8L362.1 256H481C524.5 203 522.4 123.7 473.7 73.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/heartbeat.js
// module id = 6yj9
// module chunks = 0